import { translate } from 'react-i18next';
import axios from 'axios';
import moment from 'moment';

const getLanguage = (user, subscriber, defaultLanguage = 'en') => {
  let currLanguage = defaultLanguage;
  if (user && user.language) {
    currLanguage = user.language;
  } else if (subscriber && subscriber.language) {
    currLanguage = subscriber.language;
  }
  return currLanguage;
};

const createLangOptions = (langs) => {
  const langOptions = {};
  langs.map(lang => langOptions[lang.name] = lang.title);
  return langOptions;
};

const changeLanguage = (i18n, language) => {
  i18n.changeLanguage(language);
  axios.defaults.headers.common['Accept-Language'] = language;
  moment.locale(language);
};


export default { core: translate('portal'), getLanguage, createLangOptions, changeLanguage };



// WEBPACK FOOTER //
// ./src/helpers/ml.helper.js